module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u__margin-bottom"
  }, [_c('h4', {
    staticClass: "group__headline"
  }, [_vm._v("Stripe")]), _vm._v(" "), (_vm.model.stripe) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Enabled"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.model.stripe.enabled),
      callback: function($$v) {
        _vm.$set(_vm.model.stripe, "enabled", $$v)
      },
      expression: "model.stripe.enabled"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.model.stripe.enabled),
      callback: function($$v) {
        _vm.$set(_vm.model.stripe, "enabled", $$v)
      },
      expression: "model.stripe.enabled"
    }
  }, [_vm._v("No")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Livemode"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.model.stripe.livemode),
      callback: function($$v) {
        _vm.$set(_vm.model.stripe, "livemode", $$v)
      },
      expression: "model.stripe.livemode"
    }
  }, [_vm._v("Enabled")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.model.stripe.livemode),
      callback: function($$v) {
        _vm.$set(_vm.model.stripe, "livemode", $$v)
      },
      expression: "model.stripe.livemode"
    }
  }, [_vm._v("Disabled")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Returning url"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.stripe.returning_url),
      callback: function($$v) {
        _vm.$set(_vm.model.stripe, "returning_url", $$v)
      },
      expression: "model.stripe.returning_url"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "SOFORT"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.model.stripe.enable_sofort),
      callback: function($$v) {
        _vm.$set(_vm.model.stripe, "enable_sofort", $$v)
      },
      expression: "model.stripe.enable_sofort"
    }
  }, [_vm._v("Enabled")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.model.stripe.enable_sofort),
      callback: function($$v) {
        _vm.$set(_vm.model.stripe, "enable_sofort", $$v)
      },
      expression: "model.stripe.enable_sofort"
    }
  }, [_vm._v("Disabled")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Alipay"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.model.stripe.enable_alipay),
      callback: function($$v) {
        _vm.$set(_vm.model.stripe, "enable_alipay", $$v)
      },
      expression: "model.stripe.enable_alipay"
    }
  }, [_vm._v("Enabled")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.model.stripe.enable_alipay),
      callback: function($$v) {
        _vm.$set(_vm.model.stripe, "enable_alipay", $$v)
      },
      expression: "model.stripe.enable_alipay"
    }
  }, [_vm._v("Disabled")])], 1)], 1) : _c('div', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.install('stripe', {
          returning_url: 'https://www.storyblok.com',
          livemode: '0',
          enable_sofort: '0',
          enable_alipay: '0',
        })
      }
    }
  }, [_vm._v("Install")])], 1), _vm._v(" "), _c('h4', {
    staticClass: "group__headline mt-20"
  }, [_vm._v("Cash on delivery")]), _vm._v(" "), (_vm.model.cod) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Enabled"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.model.cod.enabled),
      callback: function($$v) {
        _vm.$set(_vm.model.cod, "enabled", $$v)
      },
      expression: "model.cod.enabled"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.model.cod.enabled),
      callback: function($$v) {
        _vm.$set(_vm.model.cod, "enabled", $$v)
      },
      expression: "model.cod.enabled"
    }
  }, [_vm._v("No")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Label"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.cod.method_name),
      callback: function($$v) {
        _vm.$set(_vm.model.cod, "method_name", $$v)
      },
      expression: "model.cod.method_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Description"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.cod.form_description),
      callback: function($$v) {
        _vm.$set(_vm.model.cod, "form_description", $$v)
      },
      expression: "model.cod.form_description"
    }
  })], 1)], 1) : _c('div', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.install('cod')
      }
    }
  }, [_vm._v("Install")])], 1), _vm._v(" "), _c('h4', {
    staticClass: "group__headline mt-20"
  }, [_vm._v("Invoice")]), _vm._v(" "), (_vm.model.invoice) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Enabled"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.model.invoice.enabled),
      callback: function($$v) {
        _vm.$set(_vm.model.invoice, "enabled", $$v)
      },
      expression: "model.invoice.enabled"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.model.invoice.enabled),
      callback: function($$v) {
        _vm.$set(_vm.model.invoice, "enabled", $$v)
      },
      expression: "model.invoice.enabled"
    }
  }, [_vm._v("No")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Label"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.invoice.method_name),
      callback: function($$v) {
        _vm.$set(_vm.model.invoice, "method_name", $$v)
      },
      expression: "model.invoice.method_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Description"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.invoice.form_description),
      callback: function($$v) {
        _vm.$set(_vm.model.invoice, "form_description", $$v)
      },
      expression: "model.invoice.form_description"
    }
  })], 1)], 1) : _c('div', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.install('invoice', {
          method_name: 'Invoice',
          form_description: 'Bank account details',
        })
      }
    }
  }, [_vm._v("Install")])], 1), _vm._v(" "), _c('h4', {
    staticClass: "group__headline mt-20"
  }, [_vm._v("Paypal")]), _vm._v(" "), (_vm.model.paypal_express) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Enabled"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.model.paypal_express.enabled),
      callback: function($$v) {
        _vm.$set(_vm.model.paypal_express, "enabled", $$v)
      },
      expression: "model.paypal_express.enabled"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.model.paypal_express.enabled),
      callback: function($$v) {
        _vm.$set(_vm.model.paypal_express, "enabled", $$v)
      },
      expression: "model.paypal_express.enabled"
    }
  }, [_vm._v("No")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Username"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.paypal_express.username),
      callback: function($$v) {
        _vm.$set(_vm.model.paypal_express, "username", $$v)
      },
      expression: "model.paypal_express.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Password"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.paypal_express.password),
      callback: function($$v) {
        _vm.$set(_vm.model.paypal_express, "password", $$v)
      },
      expression: "model.paypal_express.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Signature"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.paypal_express.signature),
      callback: function($$v) {
        _vm.$set(_vm.model.paypal_express, "signature", $$v)
      },
      expression: "model.paypal_express.signature"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sandbox"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.model.paypal_express.SANDBOX),
      callback: function($$v) {
        _vm.$set(_vm.model.paypal_express, "SANDBOX", $$v)
      },
      expression: "model.paypal_express.SANDBOX"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.model.paypal_express.SANDBOX),
      callback: function($$v) {
        _vm.$set(_vm.model.paypal_express, "SANDBOX", $$v)
      },
      expression: "model.paypal_express.SANDBOX"
    }
  }, [_vm._v("No")])], 1)], 1) : _c('div', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.install('paypal_express', {
          SANDBOX: '0'
        })
      }
    }
  }, [_vm._v("Install")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d958aa3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Payment.vue
// module id = 528
// module chunks = 1